var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.gridClass,attrs:{"id":"ajax-results-container","data-pagination-insertion":"","aria-live":"polite"}},[_vm._l((_vm.publications),function(publication){return _c('li',{key:publication.Id.Int64,staticClass:"grid-item--publication"},[_c('publication',{attrs:{"publication":publication}})],1)}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }